import React from "react";
import { useTranslation, Trans } from "react-i18next";
import { ModalBuilder, Form } from "@redriver/cinnamon";
import { DropdownItem } from "semantic-ui-react";
import {
  PermissionCheck,
  UserTypeCheck,
} from "features/../../../shared/components/auth";
import { UserType } from "features/../../../shared/constants/enums";
import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { updateApplicableFrom } from "../actions";
import { NonPropagatingDate } from "features/../../../shared/components/forms/NonPropagatingField";

const UpdateApplicableFrom = ({
  sheet,
  sheetActionRequired,
  onSubmitted,
  scheduleReference,
  agreementReference,
}) => {
  const { t } = useTranslation("agreements", {
    keyPrefix: "SheetActions.UpdateApplicableFrom",
  });
  const { sheetId, availableActions } = sheet;
  if (
    (process.env.TRADE_AS_IPS &&
      !sheet.availableActionsIps[sheetActionRequired]) ||
    (!process.env.TRADE_AS_IPS &&
      !sheet.availableActionsPrincipal[sheetActionRequired])
  )
    return null;

  return (
    <UserTypeCheck restrictTo={UserType.HQ}>
      <PermissionCheck target={Targets.SheetAdmin} action={Actions.Edit}>
        <ModalBuilder
          withForm
          initialData={{
            applicableFromDate: sheet.startDate,
          }}
          renderTrigger={(showModal) => (
            <DropdownItem onClick={showModal}>{t("TriggerText")}</DropdownItem>
          )}
          submitAction={updateApplicableFrom}
          submitParams={{ sheetId }}
          onSubmitted={onSubmitted}
          renderModal={(modalProps, formProps) => (
            <TranslatedModal.Edit {...modalProps} header={t("HeaderText")}>
              <Form {...formProps}>
                <NonPropagatingDate
                  local
                  field="applicableFromDate"
                  label={t("ApplicableFrom_Label")}
                />
              </Form>

              <br />

              <p>
                <Trans
                  t={t}
                  values={{ sheetName: sheet.sheetName }}
                  components={{ s: <strong /> }}
                >
                  ConfirmSheet_Label
                </Trans>
              </p>
              <p>
                <Trans
                  t={t}
                  values={{ scheduleReference }}
                  components={{ s: <strong /> }}
                >
                  ConfirmSchedule_Label
                </Trans>
              </p>
              <p>
                <Trans
                  t={t}
                  values={{ agreementReference }}
                  components={{ s: <strong /> }}
                >
                  ConfirmAgreement_Label
                </Trans>
              </p>
            </TranslatedModal.Edit>
          )}
        />
      </PermissionCheck>
    </UserTypeCheck>
  );
};

export default UpdateApplicableFrom;
